import { mergeWith } from "lodash";
import Utils from "../../../utils/Utils";

const PostModel = (data) =>
  mergeWith(
    {},
    {
      ...data,
    },
    (o, s, k, d) => {
      if (["is_active", "is_group"].includes(k)) return Number(s);

      if (k === "content") return Utils.parseJSON(s);

      return s;
    }
  );

export { PostModel };
